export var gbIbanUtil = function() {
    // Example of a GB IBAN: GB 29 NWBK 601613 31926819
    //
    // Item             Length  Example
    // Country          2a      GB
    // IBAN Checksum    2n      29
    // SWIFT/BIC Code   4a      NWBK
    // Sort Code        6n      601613
    // Account Number   8n      31926819

    var COUNTRY_LENGTH = 2;
    var CHECKSUM_LENGTH = 2;
    var SWIFT_LENGTH = 4;
    var SORT_CODE_LENGTH = 6;
    var ACCOUNT_NUMBER_LENGTH = 8;

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    var publicMethods = {
        getCountry: function(gbIbanNumber) {
            var iban = gbIbanNumber.replace(' ', '');
            var country;

            if (isGbIbanNumberValid(iban)) {
                country = iban.substr(0, COUNTRY_LENGTH);
            }

            return country;
        },

        getChecksum: function(gbIbanNumber) {
            var iban = gbIbanNumber.replace(' ', '');
            var checksum;

            if (isGbIbanNumberValid(iban)) {
                checksum = iban.substr(COUNTRY_LENGTH, CHECKSUM_LENGTH);
            }

            return checksum;
        },

        getSwift: function(gbIbanNumber) {
            var iban = gbIbanNumber.replace(' ', '');
            var swift;

            if (isGbIbanNumberValid(iban)) {
                swift = iban.substr(COUNTRY_LENGTH + CHECKSUM_LENGTH, SWIFT_LENGTH);
            }

            return swift;
        },

        getBicCode: function(gbIbanNumber) {
            return publicMethods.getSwift(gbIbanNumber);
        },

        // Essentially this is the routing number.
        getSortCode: function(gbIbanNumber) {
            var iban = gbIbanNumber.replace(' ', '');
            var sortCode;

            if (isGbIbanNumberValid(iban)) {
                sortCode = iban.substr(COUNTRY_LENGTH + CHECKSUM_LENGTH + SWIFT_LENGTH, SORT_CODE_LENGTH);
            }

            return sortCode;
        },

        getAccountNumber: function(gbIbanNumber) {
            var iban = gbIbanNumber.replace(' ', '');
            var accountNumber;

            if (isGbIbanNumberValid(iban)) {
                accountNumber = iban.substr(COUNTRY_LENGTH + CHECKSUM_LENGTH + SWIFT_LENGTH
                    + SORT_CODE_LENGTH, ACCOUNT_NUMBER_LENGTH);
            }

            return accountNumber;
        }
    };

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    /**
     * Determins if IBAN number is valid for GB
     * @param {String} gbIbanNumber
     * @return {boolean}
     */
    function isGbIbanNumberValid(gbIbanNumber) {
        var isValid = false;

        // Just check the length for now.
        if (gbIbanNumber && gbIbanNumber.length === COUNTRY_LENGTH + CHECKSUM_LENGTH + SWIFT_LENGTH
            + SORT_CODE_LENGTH + ACCOUNT_NUMBER_LENGTH) {
            isValid = true;
        }

        return isValid;
    }

    return publicMethods;
}();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/iban-number/gb-iban.js
// module id = 337
// module chunks = 0